//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  name: 'ActiveFiltersCam',
  computed: {
    ...mapState({
      camFilter: ({ camStore: { camFilter } }) => camFilter,
      camsQuery: ({ camStore: { camsQuery } }) => camsQuery,
    }),
  },
  methods: {
    deactivate(type) {
      let subQuery = {
        type: type,
        id: '',
      };
      this.$store.commit('camStore/updateQuery', subQuery);
      let pageQuery = {
        type: 'page',
        id: 1,
      };
      this.$store.commit('camStore/updateQuery', pageQuery);
      let filterState = {
        type: type,
        name: false,
      };
      this.$store.commit('camStore/updateFilterState', filterState);
      this.$store.dispatch('camStore/getCams', this.camsQuery);
    },
  },
};
